// src/data/profile.js
// Shared by the desktop and mobile Profile (hero) views.
// Each phrase completes "I build ___" — keep them things you build, not job titles
// ("I build Problem Solver" doesn't parse; "I build real-time features" does).
export const BUILD_ITEMS = [
  'Flutter apps',
  'backend systems',
  'real-time features',
  'products that scale',
];
export const TYPE_SPEED = 65;
export const DELETE_SPEED = 35;
export const HOLD_TIME = 1400;
